export default __webpack_public_path__ + "static/media/January2019.839fa235.png";